const groupPrefix = createApiRoute(
	ApiModule.PRODUCTION_PLANNING,
	ApiAuthorization.EMPLOYEE,
	ApiDataModel.SEMI_PRODUCT_SOCKET_ASSIGNMENTS,
)

const buildAssignmentsQuery = (filters: ISemiProductSocketAssignmentFilters) => ({
	page: filters.page,
	per_page: filters.perPage,
	...(filters.assigned !== undefined ? { assigned: filters.assigned } : {}),
	...(filters.query ? { query: filters.query } : {}),
	...(filters.place ? { place: filters.place } : {}),
})

export const apiSemiProductSocketAssignments = {
	fetchSemiProductSocketAssignments: async (
		filters: ISemiProductSocketAssignmentFilters,
	): Promise<IApiResponseModel<ISemiProductSocketAssignmentModel[]>> => {
		const { data, meta } = await apiCommon<ISemiProductSocketAssignment[]>(groupPrefix, {
			method: 'GET',
			query: buildAssignmentsQuery(filters),
		})

		return { data: data ? data.map(SemiProductSocketAssignment) : [], meta }
	},

	fetchSemiProductSocketPlaces: async (): Promise<ISemiProductSocketPlace[]> => {
		const { data } = await apiCommon<ISemiProductSocketPlace[]>(`${groupPrefix}/places`, { method: 'GET' })

		return data ?? []
	},

	assignSemiProductSocket: async (crmSemiProductIds: number[], place: string): Promise<void> => {
		await apiCommon(`${groupPrefix}/assign`, {
			method: 'POST',
			body: { crm_semi_product_ids: crmSemiProductIds, place },
		})
	},

	unassignSemiProductSocket: async (crmSemiProductIds: number[]): Promise<void> => {
		await apiCommon(`${groupPrefix}/unassign`, {
			method: 'POST',
			body: { crm_semi_product_ids: crmSemiProductIds },
		})
	},
}
